import { z } from "zod";
const genesysRecordingIdSchema = z.uuid().brand();
const genesysRecordingErrorSchema = z.object({
  code: z.string(),
  message: z.string()
});
const allGenesysRecordingStatuses = [
  "pending",
  "imported",
  "failed",
  "skipped"
];
const genesysRecordingStatusSchema = z.enum(allGenesysRecordingStatuses);
const GENESYS_TRANSIENT_ERROR_CODES = [
  "attempts_exhausted",
  "recording_media_unavailable"
];
const GENESYS_MEDIA_UNAVAILABLE_ERROR_CODE = "recording_media_unavailable";
const GENESYS_PERMANENT_API_ERROR_CODE = "genesys_api_error";
const GENESYS_ACCESS_FORBIDDEN_ERROR_CODE = "recording_access_forbidden";
const GENESYS_RECORDING_MAX_ATTEMPTS = 6;
const GENESYS_RECORDING_NO_ERROR_CODE_KEY = "__none__";
const GENESYS_RECORDING_TRIAGE_PAGE_SIZE = 50;
const genesysRecordingTriageStatuses = ["failed", "skipped"];
const genesysRecordingSortOrders = ["asc", "desc"];
const genesysRecordingRequeueOutcomes = ["requeued", "noop"];
const GENESYS_RECORDING_BULK_ACTION_MAX_IDS = 1e3;
function buildGenesysInteractionUrl(region, conversationId) {
  if (!region) {
    return null;
  }
  return `https://apps.${region}/directory/#/analytics/interactions/${encodeURIComponent(
    conversationId
  )}/admin/details`;
}
const genesysFailedImportErrorLabels = {
  unresolved_agent: "Agent not matched",
  [GENESYS_PERMANENT_API_ERROR_CODE]: "Genesys API error",
  attempts_exhausted: "Import failed",
  [GENESYS_MEDIA_UNAVAILABLE_ERROR_CODE]: "Recording not ready"
};
function getGenesysFailedImportErrorLabel(code) {
  if (!code) {
    return null;
  }
  return genesysFailedImportErrorLabels[code] ?? code;
}
const GENESYS_FAILED_IMPORTS_BULK_MAX_IDS = 200;
export {
  GENESYS_ACCESS_FORBIDDEN_ERROR_CODE,
  GENESYS_FAILED_IMPORTS_BULK_MAX_IDS,
  GENESYS_MEDIA_UNAVAILABLE_ERROR_CODE,
  GENESYS_PERMANENT_API_ERROR_CODE,
  GENESYS_RECORDING_BULK_ACTION_MAX_IDS,
  GENESYS_RECORDING_MAX_ATTEMPTS,
  GENESYS_RECORDING_NO_ERROR_CODE_KEY,
  GENESYS_RECORDING_TRIAGE_PAGE_SIZE,
  GENESYS_TRANSIENT_ERROR_CODES,
  allGenesysRecordingStatuses,
  buildGenesysInteractionUrl,
  genesysFailedImportErrorLabels,
  genesysRecordingErrorSchema,
  genesysRecordingIdSchema,
  genesysRecordingRequeueOutcomes,
  genesysRecordingSortOrders,
  genesysRecordingStatusSchema,
  genesysRecordingTriageStatuses,
  getGenesysFailedImportErrorLabel
};
//# sourceMappingURL=genesysRecording.js.map
